module.exports = __webpack_public_path__ + "a548eeb5f2d6b5791fc271ee2de55ee0.svg";